import { List } from 'immutable';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';
import ValidationUtils from '../../../utils/validationUtils';

const messages = {
    requiredFields: LanguageUtils.createMessage('Price list is required')
};

export default class PricelistVersionProductStep1Validation extends ValidationUtils {
    static validateSelectedPriceList(priceListId?: number): boolean {
        return !!priceListId;
    }

    static validatePricelistVersionPriceListForm(priceListId?: number): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;

        const requiredFields = PricelistVersionProductStep1Validation.validateSelectedPriceList(priceListId);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        return validationModel;
    }
}
